// Direction + scroll bookkeeping for the cross-page SLIDE. React Router (the data
// router) now OWNS the actual document.startViewTransition() call — including on
// native browser Back/Forward — whenever a navigation opts in via
// { viewTransition: true } (see useSlideNavigate) or a POP replays an opted-in
// forward leg. React Router emits no direction and does no per-page scroll for the
// transition, so this module supplies both:
//   • direction, published as html[data-vt-dir] ("forward" | "back"), which
//     index.css keys the ::view-transition-*(root) slide animation off; and
//   • the per-history-entry window scroll, so a Back lands where you left it.
// Both are applied by <SlideDirectionBridge>, whose layout effect runs INSIDE
// React Router's transition callback (after the old snapshot, before the animation),
// exactly when the pseudo-element styles + the new snapshot are resolved.

/** Per-history-entry window scroll, keyed by React Router's monotonic history index
 *  (window.history.state.idx). Tracked continuously so a Back can restore it. */
export const scrollByIdx = new Map<number, number>();

export function historyIdx(): number {
  return (window.history.state?.idx as number | undefined) ?? 0;
}

export function setDir(dir: 'forward' | 'back'): void {
  if (typeof document !== 'undefined') document.documentElement.dataset.vtDir = dir;
}
export function clearDir(): void {
  if (typeof document !== 'undefined') delete document.documentElement.dataset.vtDir;
}

// Vestigial shared view-transition-names. The slide targets the whole viewport
// (the `root` snapshot), not per-element names, so these no longer drive anything;
// they remain only because a couple of detail pages still reference one for a
// loading-branch style. Harmless constants.
export const VT_BACKLOG_POP = 'backlog-pop';
export const VT_KB_POP = 'kb-pop';
export const VT_REQUEST_POP = 'request-pop';
export const VT_TOPIC_POP = 'topic-pop';
export const VT_TICKET_POP = 'ticket-pop';
